import { Box, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import parse from "html-react-parser";

import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import NoDataAvailableScreenWithNoCardNoButton from "../../../../components/screens/NoDataAvailableScreenWithNoCardNoButton";
import { useSnackbar } from "../../../../components/snackbars/SnackbarContext";

export default function DashboardBlogs() {
  const scrollRef = useRef(null);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const [hasFetchedNextPage, setHasFetchedNextPage] = useState(false);

  const [isAtEnd, setIsAtEnd] = useState(false);
  const [isAtStart, setIsAtStart] = useState(true);


  const { showSnackbar } = useSnackbar();



  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const fetchBlogData = async (page = 1) => {
    try {
      const response = await fetch(
        "https://stmsap-api.siectestmasters.in/api/get-blogs-details",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ limit: 6, page }),
        }
      );

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || "Failed to fetch data");

      setCardData((prev) =>
        page === 1 ? data?.data : [...prev, ...data.data]
      );
      setPagination(data.pagination);
      setHasFetchedNextPage(false);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      showSnackbar("Failed to load blogs", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogData();
  }, []);

  // Scroll detection for arrows and auto-pagination
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const atEnd =
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 60;

      const atStart = container.scrollLeft === 0;

      setIsAtEnd(atEnd);
      setIsAtStart(atStart);

      if (
        atEnd &&
        pagination.current_page < pagination.total_pages &&
        !hasFetchedNextPage
      ) {
        setHasFetchedNextPage(true);
        fetchBlogData(pagination.current_page + 1);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [pagination, hasFetchedNextPage, cardData]); // include items

  const rightArrowDisabled =
    !pagination ||
    (pagination.current_page === pagination.total_pages && isAtEnd);
  console.log(
    "rightArrowDisabled",
    pagination?.current_page,
    pagination?.total_pages,
    isAtEnd
  );

  const leftArrowDisabled = isAtStart;

  const viewDetails = (data) => {
    const url = `${data?.link || data?.alternateLink}`;
    window.open(url, "_blank"); // open in new tab
  };
  return (
    <>
      <Grid container mt={0}>
        <Grid item xs={12}>
          <CustomCardWithBorder boxShadow padding="10px">
            <Grid container>
              <Grid item xs={12} px={1}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    fontSize="20px"
                    color="#161719"
                    sx={{ fontWeight: 600, fontFamily: "Inter" }}
                  >
                    Latest Study Abroad Blogs & News
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12} mt={1}>
                {loading ? (
                  <Loader height="20vh" text="Loading Blogs..." />
                ) : cardData.length > 0 ? (
                  <Grid
                    container
                    justifyContent="center"
                    sx={{ position: "relative", width: "100%" }}
                  >
                    {/* Left Arrow */}
                    <IconButton
                      onClick={scrollLeft}
                      disabled={leftArrowDisabled}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: -5,
                        width: "25px",
                        height: "25px",
                        transform: "translateY(-50%)",
                        bgcolor: "#fff",
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                        border: "1px solid #572575",
                        "&:hover": { bgcolor: "#f2f2f2" },
                        zIndex: 2,
                        opacity: leftArrowDisabled ? 0.4 : 1,
                        transition: "opacity 0.3s",
                      }}
                    >
                      <ArrowBackIosNewIcon
                        style={{ color: "#572575", width: "15px" }}
                      />
                    </IconButton>

                    {/* Right Arrow */}
                    <IconButton
                      onClick={scrollRight}
                      disabled={rightArrowDisabled}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: -3,
                        width: "25px",
                        height: "25px",
                        transform: "translateY(-50%)",
                        bgcolor: "#fff",
                        border: "1px solid #572575",
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                        "&:hover": { bgcolor: "#f2f2f2" },
                        zIndex: 2,
                        opacity: rightArrowDisabled ? 0.4 : 1,
                        transition: "opacity 0.3s",
                      }}
                    >
                      <ArrowForwardIosIcon
                        fontSize="small"
                        style={{ color: "#572575", width: "15px" }}
                      />
                    </IconButton>

                    {/* Scrollable Cards */}
                    <Box
                      ref={scrollRef}
                      sx={{
                        display: "flex",
                        gap: 3,
                        overflowX: "auto",
                        scrollBehavior: "smooth",
                        "&::-webkit-scrollbar": { display: "none" },
                        maxWidth: {
                          xs: "300px",
                          sm: "500px",
                          md: "960px",
                          lg: "1024px",
                          xl: "1200px",
                        },
                        padding: "5px",
                      }}
                    >
                      {cardData.map((data, index) => (
                        <Box
                          key={data?.id || index}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: "12px",
                            border: "1px solid #D0D0D0",
                            width: { xs: "300px", sm: "500px", md: "350px" },
                            flexShrink: 0,
                            backgroundColor: "white",
                            paddingBottom: "10px",
                          }}
                        >
                          <Box>
                            <Grid container>
                              <Grid item xs={12} position="relative">
                                <Box
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    overflow: "hidden",
                                    zIndex: 1,
                                  }}
                                >
                                  <img
                                    src={data?.image}
                                    alt={data?.blog_name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      display: "block",
                                      borderTopLeftRadius: "12px",
                                      borderTopRightRadius: "12px",
                                    }}
                                  />
                                </Box>
                                {data?.sub_service && (
                                  <Box
                                    position="absolute"
                                    bottom={0}
                                    left={0}
                                    sx={{
                                      backgroundColor: "#F9D359",
                                      padding: "10px",
                                      borderTopRightRadius: "6px",
                                      borderBottomRightRadius: "6px",
                                      borderLeft: "none", // optional: remove left border if desired
                                      paddingX: "30px",
                                    }}
                                  >
                                    <Typography
                                      fontSize="14px"
                                      fontWeight={800}
                                      color="#000000"
                                      fontFamily="Inter"
                                    >
                                      {data?.sub_service}
                                    </Typography>
                                  </Box>
                                )}
                              </Grid>

                              <Grid item xs={12} mt={1}>
                                <Grid container spacing={2} px={2}>
                                  <Grid item xs={10} textAlign="start">
                                    <Typography
                                      fontSize="16px"
                                      fontWeight={600}
                                      color="#161719"
                                      fontFamily="Inter"
                                    >
                                      {data?.blog_name}
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    xs={2}
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => viewDetails(data)}
                                  >
                                    <Box width={40}>
                                      <img src="/newdashboard/Blog/Component 466.png" />
                                    </Box>
                                  </Grid>

                                  {/* <Grid item xs={12} textAlign="start">
                                    <Typography
                                      fontSize="12px"
                                      color="#5F6570"
                                      fontFamily="Inter"
                                      fontWeight={500}
                                    >
                                      {parse(String(data?.blog_short_content))}
                                    </Typography>
                                  </Grid> */}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} mt={2}>
                    <NoDataAvailableScreenWithNoCardNoButton
                      topImage={
                        <img src="/PurchaseTest/Group 1171283373 (3).png" />
                      }
                      topimageWidth="88px"
                      text="No Data Available!"
                      subText="Unable to load data. Please try again later."
                      maxWidth="100%"
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </CustomCardWithBorder>
        </Grid>
      </Grid>

      
    </>
  );
}
